/* @flow*/
import 'lib/fastClick';
import 'react-hot-loader';
import simulate from 'lib/simulate';
import $ from 'jquery';
import history from 'lib/history';
import 'bootstrap';
import Turbolinks from 'turbolinks';

window.$ = window.jQuery = $;
window.Turbolinks = Turbolinks;
Turbolinks.start();

// Hack to get around incompatibility between Turbolinks and react-router history
// see: https://github.com/shakacode/react_on_rails/issues/613
addEventListener('popstate', () => {
  const { state } = window.history || {};
  if (!(state && state.turbolinks)) {
    Turbolinks.visit(location.href, { action: 'replace' });
  }
});

addEventListener('turbolinks:load', function() {
  // Signed out. Clear CONFIG object.
  if (String(history.getKey('s')) === '1') {
    window.CONFIG.ME = {};
    history.deleteKey('s');
  }
});

window.simulate = simulate;
